export const contentStyles = {
  heading: { mt: 14, mb: 6 },
  link: { fontSize: "inherit" },
  paragraph: { lineHeight: "tall", fontSize: "lg", mb: 4, _last: { mb: 0 } },
  horizontalRule: { borderColor: "greyscale.400", my: { base: 6, lg: 8 } },
  list: {
    li: { mb: 4, ml: 8 },
    "li > p": { ml: 4 },
    "li::marker": {
      fontWeight: "semibold",
      fontSize: "lg",
      color: "primary.500",
    },
  },
};
